<div class="blob-loader-wrapper">
  <p><span></span></p>
  <p><span></span></p>
</div>